export const BET_STATUS = {
  LOST: 'l',
  HALF_LOST: 'hl',
  REFUND: 'r',
  HALF_WIN: 'hw',
  WIN: 'w',
};

export const BET_MARKET = {
  TOTAL: 'total',
  HANDICAP: 'handicap',
  HDP: 'hdp',
};

export const BET_PART = {
  FT: 'FT',
  HT: 'HT',
};

export const BET_SIGNAL = {
  TICKER: 'ticker',
};

// Ticker forecasts are stored per subtype on the server; the dashboard shows the bot name.
export const TICKER_SIGNALS = [
  'tickerSharp',
  'tickerWhale',
  'tickerLowTrended',
  'tickerHighTrended',
];
